import { IAstrologer } from '../redux/astrologer/types';
import { BaseService } from './BaseService';

export class AstrologerService extends BaseService {
  async getMatchedAstrologer(): Promise<IAstrologer> {
    return this.httpClient.get('/funnel/matching/astrologer');
  }
}
